import { useState } from "react";
import { POPULAR_CITIES } from "../lib/cities";
import { MapPin } from "lucide-react";

export const CityAutocomplete = ({ value, onChange, placeholder, testId }) => {
  const [open, setOpen] = useState(false);
  const q = (value || "").trim().toLowerCase();
  const suggestions =
    q.length >= 1 ? POPULAR_CITIES.filter((c) => c.toLowerCase().includes(q)).slice(0, 8) : [];

  return (
    <div className="relative w-full">
      <input
        data-testid={testId}
        value={value}
        autoComplete="off"
        onChange={(e) => {
          onChange(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder={placeholder}
        className="w-full px-4 py-3 rounded-xl border border-border bg-white/70 outline-none focus:border-[#1A3B2B] transition-colors"
      />
      {open && suggestions.length > 0 && (
        <ul
          data-testid={`${testId}-suggestions`}
          className="absolute z-20 left-0 right-0 mt-2 max-h-64 overflow-auto rounded-xl border border-border bg-white shadow-md"
        >
          {suggestions.map((c) => (
            <li key={c}>
              <button
                type="button"
                onMouseDown={(e) => {
                  e.preventDefault();
                  onChange(c);
                  setOpen(false);
                }}
                className="w-full flex items-center gap-2 px-4 py-2.5 text-left text-sm hover:bg-[#F3EFE8] transition-colors"
              >
                <MapPin className="w-4 h-4 text-[#C8553D] shrink-0" />
                {c}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
